import moment from "moment";
import {
  addressData,
  addressRules,
  contactData,
  contactRules,
  documentsData,
  takerData,
  takerRules,
} from "../new-insured/utils";
import { FormValues } from "../hooks/hooks.types";
import { validateFields } from "../components/assets";
import { deepGet } from "../../../../utils/utility";
import { isValidIban } from "../../../../utils/iban";
import { validateStandarisedFieldsSupplements } from "../../../../utils/validation";
import { FormatedSupplementDoc } from "../utils.type";

export const initialStepperPolicyHolderChangeData = () => {
  return {
    taker: takerData, // step 1
    address: addressData, // step 1
    contact: contactData, // step 1
    dataProtectionDetails: {
      consentDate: moment().format('DD/MM/YYYY'),
      dataTransfer: "",
      writtenAdvertisementDispatch: "",
      productPromotionCallTransfer: "",
      dataTransferValue: null,
      writtenAdvertisementDispatchValue: null,
      productPromotionCallTransferValue: null,
    }, // step 2
    policy: { startDate: moment().format('DD/MM/YYYY'), payType: null, iban: "", payTypeValue: ""}, // step 3
    insurancePaymentDetails: {}, // step 3
    documents: documentsData, // step 4
    isChangePolicyHolder: true,
  };
};

export const validatePolicyHolderData = (values: FormValues, supplementsDocs: FormatedSupplementDoc[]) => {
  let { errors: takerErrors, hasValidation: takerHasValidation } = validateFields(values.taker, takerRules((deepGet(values, 'taker.docType',) || ''), values.taker), );
  const isOnChangeEvent = false;
  Object.keys(values.taker).forEach(key => {
    const validation = validateStandarisedFieldsSupplements(values.taker[key], key, isOnChangeEvent);
    
    if(validation && validation.isError){
      takerErrors = {
        ...takerErrors,
        [key]: validation.errorCode,
      }
      takerHasValidation = false;
    }
  });

  const { errors: addressErrors, hasValidation: addressHasValidation } = validateFields(values.address, addressRules);
  const { errors: contactErrors, hasValidation: contactHasValidation } = validateFields(values.contact, contactRules);
  const { errors: dataProtectioErrors, hasValidation: dataProtectioHasValidation } = validateFields(values.dataProtectionDetails, dataProtectionRules);
  const { errors: policyErrors, hasValidation: policyHasValidation } = validateFields(values.policy, policyRules);
  const documents = {uploadDocuments: values.documents, supplementsDocs}
  const { errors: documentsErrors, hasValidation: documentsHasValidation } = validateFields(documents, documentsRules);

  const hasStepOneValidation =
    takerHasValidation && contactHasValidation && addressHasValidation;

  return {
    errors: {
      taker: takerErrors,
      contact: contactErrors,
      address: addressErrors,
      dataProtection: dataProtectioErrors,
      policy: policyErrors,
      documents: {documents: documentsErrors.uploadDocuments},
    },
    hasStepOneValidation,
    dataProtectioHasValidation,
    policyHasValidation,
    documentsHasValidation
  };
};

export const dataProtectionRules = {
  dataTransferValue: (dataTransferValue: boolean | null) => {
    return dataTransferValue === null ? 'required' : null;
  },
  writtenAdvertisementDispatchValue: (writtenAdvertisementDispatchValue: boolean | null) => {
    return writtenAdvertisementDispatchValue === null ? 'required' : null;
  },
  productPromotionCallTransferValue: (productPromotionCallTransferValue: boolean | null) => {
    return productPromotionCallTransferValue === null ? 'required' : null;
  },
};

export const policyRules = { 
  payTypeValue: (payTypeValue: string) => {
    return payTypeValue === "" ? 'required' : null;
  },
  iban: (iban: string) => {
    if (!iban) return 'required'
    return !isValidIban(iban) ? 'invalid-iban' : null;
  },
};

export const documentsRules = {  
  uploadDocuments: (documents: { uploadDocuments: {type: string}[], supplementsDocs: FormatedSupplementDoc[]}) => {
    if (!documents.supplementsDocs) return null;

    const requiredDocs = documents.supplementsDocs.filter((doc) => doc.required);
    if (!requiredDocs) return null;

    let error = "";
    requiredDocs.forEach((requiredDoc) => {
      const uploadDoc = documents.uploadDocuments.find((doc) => doc.type === requiredDoc.value);
      if (!uploadDoc) {
        error = `${error ? error + " - " : ""}${requiredDoc.label}`;
      }
    });
    return error;
  },
};
